var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-wrap my-auto" },
      _vm._l(_vm.origins, function(origin, index) {
        return _c("div", { key: index, staticClass: "ma-1" }, [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                "div",
                {
                  staticClass: "font-weight-bold text-no-wrap",
                  staticStyle: { width: "min-content" }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(origin.description) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-checkbox", {
                staticClass: "ma-0 pa-0",
                attrs: {
                  "input-value": _vm.isGroupChecked(origin.id),
                  dense: "",
                  "hide-details": ""
                },
                on: {
                  change: function($event) {
                    return _vm.handleGroupCheckedClick(origin.id)
                  }
                }
              })
            ],
            1
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-grow-0 ml-2 my-auto" },
      [
        _c(
          "v-btn",
          {
            staticClass: "text-none my-2",
            attrs: { color: "primary", text: "" },
            on: { click: _vm.clearAttributesObj }
          },
          [
            _c("v-icon", [
              _vm._v(_vm._s(_vm.generateMessage("boilerplate.icons.refresh")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-decoration-underline" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.generateMessage("boilerplate.filters.reset")) +
                  "\n      "
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("custom-page-selector", { attrs: { namespace: "logbook" } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }